module.exports = __webpack_public_path__ + "images/img-3fA9Agk.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/ranks/0.jpg
// module id = 2033
// module chunks = 0